import { Button } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled, { css } from 'styled-components';
import media from '../media';

const activeCss = ({ theme }: WithTheme) => css`
  color: ${theme.color.bulma[100]};
  &:after {
    transform: scaleX(1);
  }
`;

const TabLink = styled(Button)`
  position: relative;
  padding: 0 0 ${rem(14)};
  font-size: ${rem(14)};
  line-height: 1.3;
  text-decoration: none;
  color: ${({ theme }) => theme.color.trunks[100]};
  transition: color 0.2s ease;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: ${rem(2)};
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.color.piccolo[100]};
    margin: 0 auto;
    transform: scaleX(0);
    transition: transform 0.2s ease;
  }

  ${media.desktopSmall} {
    &:hover {
      ${activeCss}
    }
  }

  &.active {
    ${activeCss}
  }
`;

export default TabLink;
